import { selectBoostManager } from '../selectors/boost';
import { useAppSelector } from '../store/store';
export default function useBoostManager() {
    const boostManager = useAppSelector(selectBoostManager);
    return boostManager;
}
